/** Required / Recommended marker rendered next to a field label. Mirrors the
 *  AWS-program priority signal carried on intake `FieldDef.priority` and on
 *  proposal-side `PROPOSAL_HELP.priority` entries.
 *
 *  Required is the *default expectation* of a form field, so it's marked with a
 *  quiet red asterisk rather than a loud filled chip (which created badge
 *  fatigue — see DESIGN.md §3.3). Recommended is the genuinely useful, unusual
 *  signal in this product (it drives report quality), so it keeps an amber chip.
 *  Both keep their `priority-{required|recommended}` test ids. */

interface Props {
  priority: 'required' | 'recommended' | undefined
}

export function PriorityBadge({ priority }: Props) {
  if (!priority) return null
  if (priority === 'required') {
    return (
      <span
        data-testid="priority-required"
        title="Required for AWS Fund Request submission"
        aria-label="required"
        style={{
          marginLeft: '0.3rem',
          color: 'var(--accent)',
          fontWeight: 700,
          lineHeight: 1,
        }}
      >
        *
      </span>
    )
  }
  return (
    <span
      data-testid="priority-recommended"
      className="chip chip--warn"
      title="Recommended for a high-quality assessment"
      style={{ marginLeft: '0.4rem', fontSize: '0.6rem', textTransform: 'uppercase', letterSpacing: '0.04em' }}
    >
      Recommended
    </span>
  )
}
